import { render, staticRenderFns } from "./editcrimetype.vue?vue&type=template&id=7561defa"
import script from "./editcrimetype.vue?vue&type=script&lang=js"
export * from "./editcrimetype.vue?vue&type=script&lang=js"
import style0 from "./editcrimetype.vue?vue&type=style&index=0&id=7561defa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports